module.exports = __webpack_public_path__ + "media/LMB_Garden2_but_with_bird.de567996.mp3";